import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#faf8f3" }}>
        <div className="w-10 h-10 border-4 border-[#1a6b3c] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;
  if (!user.role) return <Navigate to="/select-role" replace />;

  // Redirect to correct dashboard based on role instead of looping
  if (requiredRole && user.role !== requiredRole && user.role !== "admin") {
    if (user.role === "landlord") return <Navigate to="/landlord-dashboard" replace />;
    if (user.role === "renter") return <Navigate to="/dashboard" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
}
